<template lang='pug'>
  .join-container
    .title(v-text='$t("title")')
    .description(v-text='$t("description")')
    .sessions
      a.btn.register(:href='registerPath()' v-text='$t("account.user.register")')
      a.btn.sign-in(:href='signInPath()' v-text='$t("account.user.signIn")')
</template>

<i18n>
{
  "lng_en": {
    "title": "join beauty pass",
    "description": "When you sign up for Beauty Pass, you'll instantly receive 50 bonus points that you can use to redeem rewards from your reward boutique. Get started and sign up now."
  },
  "lng_id": {
    "title": "Bergabung dengan beauty pass",
    "description": "Ketika Anda mendaftar untuk Beauty Pass, Anda secara otomatis mendapatkan bonus 50 poin yang bisa digunakan untuk redeem rewards dari reward boutique yang tersedia. Mulailah sekarang dan daftar segera."
  },
  "lng_th": {
    "title": "สมัคร beauty pass",
    "description": "เมื่อคุณลงทะเบียน Beauty Pass คุณจะได้รับคะแนน Bonus point 50 คะแนน ซึ่งสามารถนำมาแลกรับของรางวัลได้ ลงทะเบียนตอนนี้"
  },
  "lng_zh": {
    "title": "加入beauty pass",
    "description": "註冊Beauty Pass即可獲得50迎新積分用於兌換獎賞廊美妝產品。立即註冊賺取積分。"
  },
  "lng_ko": {
    "title": "뷰티 패스 가입하기",
    "description": "뷰티패스에 가입하면 즉시 보너스 50포인트를 받고 리워드 부티크에서 혜택을 사용할 수 있습니다.지금 로그인하고 시작하기"
  }
}
</i18n>

<script>
import { sessionUtil } from '@/mixins/pathUtil'

export default {
  mixins: [
    sessionUtil
  ]
}
</script>

<style lang='scss' scoped>
  .join-container {
    padding-bottom: 25px;
    padding-top: 30px;

    > .title {
      @include font-sephora-serif;
      font-size: 30px;
      line-height: 32px;
      margin-left: auto;
      margin-right: auto;
      text-transform: uppercase;
      width: 80%;
    }

    > .description {
      margin-left: auto;
      margin-right: auto;
      margin-top: 10px;
      width: 90%;
    }
  }

  .sessions {
    display: flex;
    margin: 20px 5% 5px;

    @include media-breakpoint-up(sm) {
      margin-left: auto;
      margin-right: auto;
      width: 550px;
    }

    > .register {
      flex-grow: 1;
    }

    > .sign-in {
      background: white;
      border: 1px solid black;
      color: black;
      flex-grow: 1;
      margin-left: 5%;

      @include media-breakpoint-up(sm) {
        margin-left: 30px;
      }
    }
  }
</style>
